<template>
  <div>
    <div class="tw:flex tw:flex-col tw:gap-[2px] tw:mb-4">
      <h4 class="tw:font-bold">{{ $t('sub_cancel_info', { EndDate: subscriptionEndDate }) }}</h4>
      <p>{{ $t('sub_cancel_subtext') }}</p>
    </div>
    <div class="tw:bg-green-100 tw:rounded-xl tw:p-3 tw:mb-6">
      <h5 class="tw:font-bold tw:text-sm tw:mb-2">{{ $t('business_studio_benefits_header') }}</h5>
      <ul class="tw:mb-2">
        <li
          v-for="(item, index) in withStudioBenefits"
          :key="index"
          class="tw:text-sm tw:flex tw:gap-y-[2px] tw:items-center tw:gap-x-2"
        >
          <img :src="CheckIcon" alt="Check Icon" class="tw:w-6 tw:h-6" />
          <span v-if="index === 0">{{
            $t(item, {
              PercentageIncrease: formatPercentage(10, 0, 2),
            })
          }}</span>
          <span v-else>{{ $t(item) }}</span>
        </li>
      </ul>
      <p class="tw:text-xs tw:text-gray-600">{{ $t('plus_benefit_disclaimer') }}</p>
    </div>
    <BookMeetingCard :accommodationId="accommodationId" />
  </div>
</template>
<script setup>
import { computed } from 'vue'

import BookMeetingCard from '@/components/billing/premiumProducts/cancellation/BookMeetingCard.vue'

import { useFormatting } from '@/composables/useFormatting'

const CheckIcon = new URL('/src/assets/img/studio-plus/CheckIcon.svg', import.meta.url)

const props = defineProps({
  endDate: Date,
  accommodationId: Number,
})

const { formatDate, formatPercentage } = useFormatting()
const withStudioBenefits = ['plus_benefit_1', 'plus_benefit_2', 'plus_benefit_3', 'plus_benefit_4', 'plus_benefit_5']
const subscriptionEndDate = computed(() => {
  if (props.endDate) {
    return formatDate(props.endDate, {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    })
  } else return ''
})
</script>
<style scoped>
p :deep(a) {
  text-decoration: underline;
}
</style>
